import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import { Wrapper, Text, MobileText } from './ProductsTabs.style';
import { PromoteLinkButton } from './PromoteTabs.style';

interface LinkType {
  text: string;
  url: string;
  mobileText?: string;
}

const tabs: LinkType[] = [
  { text: 'Premier Listing', url: '/promote/premier', mobileText: 'Premier' },
  { text: 'Featured Listing', url: '/promote/featured', mobileText: 'Featured' },
  { text: 'Premier Boost', url: '/promote/boost', mobileText: 'Boost' },
];

interface PromoteTabsProps extends React.HTMLAttributes<HTMLDivElement> {
  propertyId?: string;
}

const PromoteTabs: FunctionComponent<PromoteTabsProps> = ({ propertyId, ...props }) => {
  const router = useRouter();

  return (
    <div {...props}>
      <Wrapper>
        {tabs.map((link) => (
          <PromoteLinkButton
            $active={router.pathname === link.url}
            key={link.text}
            data-testid={`promote-link-${link.text.toLowerCase().replace(' ', '-')}`}
            type="button"
            prefetch={false}
            href={`${link.url}${propertyId ? `?propertyId=${propertyId}` : ''}`}
          >
            <Text data-testid="promote-text">{link.text}</Text>
            <MobileText data-testid="promote-mobile-text">{link.mobileText || link.text}</MobileText>
          </PromoteLinkButton>
        ))}
      </Wrapper>
    </div>
  );
};

export default PromoteTabs;
